import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryVirtualListItem = _resolveComponent("PantryVirtualListItem")

  return (_openBlock(), _createBlock("div", {
    class: "pantry-virtual-list-line-view",
    style: _ctx.styleView()
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getList(), (item) => {
      return (_openBlock(), _createBlock(_component_PantryVirtualListItem, {
        key: item.id,
        id: item.id,
        linePosition: _ctx.linePosition,
        data: item.data,
        selectMode: _ctx.selectMode,
        onSelectCheck: _ctx.onSelectCheck
      }, null, 8, ["id", "linePosition", "data", "selectMode", "onSelectCheck"]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 4))
}